import logger from '@finn-no/fiaas-logger';
import type { GetServerSidePropsContext, GetServerSidePropsResult } from 'next';
import { getPageCounter } from 'shared/prometheus/prometheus';
import { Out, type OutProps } from '@/components/outpage/Out';
import { config, feConfig } from '@/config';
import type { LmsOfferResponse } from '@/interfaces/lms';

type LmsOutPageProps = OutProps;

const LmsOutPage = (props: LmsOutPageProps) => <Out {...props} vertical="lms" />;

// biome-ignore lint/suspicious/noExplicitAny: This was set before biome was added
export const getServerSideProps = async ({ query }: GetServerSidePropsContext): Promise<GetServerSidePropsResult<any>> => {
    const lmsOfferUrl = `${config.get('lms.apiUrlInternal')}/offer?offerId=${query.offerId}`;

    const data: LmsOfferResponse | null = await fetch(lmsOfferUrl)
        .then((response): Promise<LmsOfferResponse> => response.json())
        .catch((err) => {
            logger.error(`Could not fetch lms offer data from ${lmsOfferUrl}`, err);
            return null;
        });

    if (!data) {
        return { props: { config: feConfig } };
    }

    getPageCounter().inc({ app: 'pale-pp-web', page: 'lms-ut' });

    return {
        props: {
            // Must be set to null specifically, as undefined cannot be serialized (which is done when sending data to the client)
            offerId: query.offerId ?? null,
            supplier: data.brand ?? null,
            deepLink: data.deepLink ?? null,
            fromPage: query.fromPage ?? null,
            config: feConfig,
        },
    };
};

export default LmsOutPage;
